const pad2 = (value) => String(value).padStart(2, "0");

// Calendar date in the user's local timezone. Do not use toISOString here:
// UTC conversion can move India/Asia dates to the previous day.
export const toLocalYmd = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};

export const localToday = () => toLocalYmd(new Date());
